import { logOut } from '../store/actions/login/loginActions';
import UserRoleApi from '../API/UserRoleAPI';
import { CHECK_LOGIN_TIMER } from './Constants';

let timer;
let timeoutMinutes = 30;
let user = '';
let interval;

export const setLogoutTimeout = (minutes, username) => {
    timeoutMinutes = minutes;
    user = username;
    timer = setTimeout(logout, minutes * 60 * 1000);
}

export const resetLogoutTimeout = (username) => {
    clearTimeout(timer);
    user = username;
    timer = setTimeout(logout, timeoutMinutes * 60 * 1000);
}

export const setLoginInterval = (username) => {
    const userRoleApi = new UserRoleApi();

    interval = setInterval(() => {
        userRoleApi.checkUserLogin(username).then(ok => {
            if(!ok.data) {
                window.removeEventListener("beforeunload", onUnload);
                logOut();
                window.location.reload();
            }
        });
    }, CHECK_LOGIN_TIMER);
}

export const clearLoginInterval = () => {
    clearInterval(interval);
}

export const onUnload = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    event.returnValue = '';

    clearLoginInterval();

    const userRoleApi = new UserRoleApi();
    await userRoleApi.logout(user);
    logOut();

    window.removeEventListener("beforeunload", onUnload);
    window.location.reload(); 

    return '';
}

const logout = () => {
    window.removeEventListener("beforeunload", onUnload);
    clearLoginInterval();

    const userRoleApi = new UserRoleApi();
    userRoleApi.logout(user).then(ok => {
        logOut();
        window.location.reload();
    }).catch(err => {
        console.log(err)
        window.location.reload();
    })
    
}


// WEBPACK FOOTER //
// ./src/Utils/Timer.js